/**
 * Pages where PostHog click/scroll heatmaps are captured.
 *
 * Heatmaps are off site-wide (`capture_heatmaps: false` in
 * `src/components/providers/posthog-provider.tsx`): the extra pointer/scroll
 * observer costs mid-range Android 50–150 ms INP per interaction, and the job
 * feed carries almost all of our traffic. That left the pages where we make
 * pricing and B2B decisions with no click map at all — on 2026-11-04 a
 * 30-day `heatmaps-list` for `/pricing` returned 0 click points, so the
 * pricing/checkout review had to be reconstructed from autocapture text.
 *
 * These routes are low-traffic decision pages (≈100 human visitors/30 d on
 * `/pricing`, ≈30 on `/employers`), so the INP cost lands on a small share of
 * sessions while the feed keeps heatmaps off. Add a route only for a page
 * whose layout we are actively deciding on.
 */
const HEATMAP_ROUTE_PATTERNS: readonly RegExp[] = [
	/^\/(?:id|en)\/pricing\/?$/,
	/^\/(?:id|en)\/employers(?:\/.*)?$/,
	/^\/(?:id|en)\/tools(?:\/.*)?$/,
];

export function isHeatmapRoute(pathname: string | null | undefined): boolean {
	if (!pathname) return false;
	return HEATMAP_ROUTE_PATTERNS.some((re) => re.test(pathname));
}
